<template>
  <FrontendLayoutAccount>
    <template #title>Siparişlerim</template>

    <div v-if="loading">
      <FrontendSkeletonOrderList />
    </div>

    <div v-else-if="!orderState.orders?.length" class="text-center py-12">
      <UIcon name="i-heroicons-shopping-bag" class="w-12 h-12 mx-auto text-gray-400" />
      <h3 class="mt-2 text-sm font-semibold text-gray-900">
        Henüz siparişiniz yok
      </h3>
      <p class="mt-1 text-sm text-gray-500">
        Alışverişe başlamak için aşağıdaki butona tıklayın.
      </p>
      <div class="mt-6">
        <UButton to="/" variant="soft">Alışverişe Başla</UButton>
      </div>
    </div>

    <div v-else class="space-y-6">
      <div class="space-y-4">
        <FrontendOrderCard v-for="order in orderState.orders" :key="order.id" :order="order" />

        <!-- Sayfalama kontrolleri -->
        <div v-if="orderState.pagination.last_page > 1" class="py-4 border-t border-gray-100">
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-600">
              Toplam {{ orderState.pagination.total }} sipariş
            </span>

            <!-- UPagination Komponenti -->
            <UPagination v-model="currentPage" :total="orderState.pagination.total"
              :page-count="orderState.pagination.per_page" :max="7" show-first show-last class="mt-0" :to="(page) => ({
                path: route.path,
                query: {
                  ...route.query,
                  page
                }
              })" />
          </div>
        </div>
      </div>
    </div>
  </FrontendLayoutAccount>
</template>

<script setup>
useHead({
  title: 'Siparişlerim - Beyraha'
})

const orderState = useOrderStoreFront()
const loading = ref(true)
const route = useRoute()

// Mevcut sayfa numarası (UPagination v-model için)
const currentPage = computed({
  get: () => orderState.pagination.current_page,
  set: (page) => changePage(page)
})

// Sayfa değiştirme işlemi
const changePage = async (page) => {
  if (page < 1 || page > orderState.pagination.last_page) return

  loading.value = true
  try {
    // Verileri getir
    await orderState.getOrders(page)
  } finally {
    loading.value = false

    // Sayfa değiştiğinde en yukarı kaydır
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

// Sayfa yüklendiğinde siparişleri getir
const getOrders = async () => {
  const page = parseInt(route.query.page) || 1

  try {
    await orderState.getOrders(page)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  getOrders()
})

// URL parametreleri değiştiğinde siparişleri yeniden getir
watch(() => route.query.page, (newPage) => {
  if (newPage) {
    getOrders()
  }
})
</script>
